// src/components/ContactForm.js
import React, { useState, useEffect } from 'react';
import './ContactForm.css'; // Importa os estilos que criaremos a seguir
import { db } from '../firebase';
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const ContactForm = ({ initialMessage = '' }) => {
  const [formData, setFormData] = useState({
    nome: '',
    sobrenome: '',
    telefone: '',
    email: '',
    empresa: '',
    cnpj: '',
    necessidade: initialMessage,
    aceitouTermos: false,
    aceitouMarketingTelefone: false,
    aceitouMarketingEmail: false,
  });

  // NOVO: Use useEffect para atualizar a 'necessidade' se initialMessage mudar
  useEffect(() => {
    setFormData(prev => ({ ...prev, necessidade: initialMessage }));
  }, [initialMessage]);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const val = type === 'checkbox' ? checked : value;
    setFormData(prevState => ({ ...prevState, [name]: val }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // --- ALTERAÇÃO PRINCIPAL AQUI ---
      // O caminho agora aponta para a sub-coleção dentro do documento 'site_data'
      const docRef = await addDoc(collection(db, "pts-com-br", "site_data", "contactRequestForm"), {
        dadosCliente: {
          nome: formData.nome,
          sobrenome: formData.sobrenome,
          telefone: formData.telefone,
          email: formData.email,
          empresa: formData.empresa,
          cnpj: formData.cnpj,
          necessidade: formData.necessidade,
        },
        consentimentos: {
          aceitouTermos: formData.aceitouTermos,
          dataAceiteTermos: formData.aceitouTermos ? serverTimestamp() : null,
          aceitouMarketingTelefone: formData.aceitouMarketingTelefone,
          dataAceiteMarketingTelefone: formData.aceitouMarketingTelefone ? serverTimestamp() : null,
          aceitouMarketingEmail: formData.aceitouMarketingEmail,
          dataAceiteMarketingEmail: formData.aceitouMarketingEmail ? serverTimestamp() : null,
        },
        status: 'novo', // O status padrão do ticket
        dataCriacao: serverTimestamp()
      });

      alert("Solicitação enviada com sucesso! ID: " + docRef.id);
      
      // Limpa o formulário
      setFormData({
        nome: '', sobrenome: '', telefone: '', email: '',
        empresa: '', cnpj: '', necessidade: '',
        aceitouTermos: false, aceitouMarketingTelefone: false, aceitouMarketingEmail: false,
      });

    } catch (error) {
      console.error("Erro ao enviar a solicitação: ", error);
      alert("Ocorreu um erro ao enviar sua solicitação. Por favor, tente novamente.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact-form-section" className="contact-form-section">
      <div className="container">
        <h2 className="section-title">Fale com um Especialista</h2>
        <p className="section-subtitle">Informe sua necessidade e retornaremos o contato em breve!</p>
        
        <form className="form-grid" onSubmit={handleSubmit}>
          {/* Campos do formulário exatamente como no outro projeto */}
          <div className="form-group">
            <label htmlFor="nome">Nome *</label>
            <input type="text" id="nome" name="nome" value={formData.nome} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label htmlFor="sobrenome">Sobrenome</label>
            <input type="text" id="sobrenome" name="sobrenome" value={formData.sobrenome} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label htmlFor="telefone">Telefone *</label>
            <input type="tel" id="telefone" name="telefone" value={formData.telefone} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email *</label>
            <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required />
          </div>
          <div className="form-group">
            <label htmlFor="empresa">Empresa</label>
            <input type="text" id="empresa" name="empresa" value={formData.empresa} onChange={handleChange} />
          </div>
          <div className="form-group">
            <label htmlFor="cnpj">CNPJ</label>
            <input type="text" id="cnpj" name="cnpj" value={formData.cnpj} onChange={handleChange} />
          </div>
          <div className="form-group full-width">
            <label htmlFor="necessidade">Informe a sua necessidade: *</label>
            <textarea id="necessidade" name="necessidade" rows="6" value={formData.necessidade} onChange={handleChange} required></textarea>
          </div>
          
          {/* Checkboxes LGPD */}
          <div className="form-group-checkbox full-width">
            <input type="checkbox" id="aceitouTermos" name="aceitouTermos" checked={formData.aceitouTermos} onChange={handleChange} required />
            <label htmlFor="aceitouTermos">Concordo com os <a href="/termos-e-condicoes" target="_blank" rel="noopener noreferrer">termos e condições</a> e com a <a href="/politica-de-privacidade" target="_blank" rel="noopener noreferrer">política de privacidade</a>.</label>
          </div>
          <div className="form-group-checkbox full-width">
            <input type="checkbox" id="aceitouMarketingTelefone" name="aceitouMarketingTelefone" checked={formData.aceitouMarketingTelefone} onChange={handleChange} />
            <label htmlFor="aceitouMarketingTelefone">Aceito receber comunicações da Primo Trade Solutions por Telefone e Whatsapp.</label>
          </div>
          <div className="form-group-checkbox full-width">
            <input type="checkbox" id="aceitouMarketingEmail" name="aceitouMarketingEmail" checked={formData.aceitouMarketingEmail} onChange={handleChange} />
            <label htmlFor="aceitouMarketingEmail">Aceito receber comunicações da Primo Trade Solutions por e-mail.</label>
          </div>
          
          <div className="form-group full-width">
            <button type="submit" className="submit-button" disabled={isSubmitting}>
              {isSubmitting ? 'Enviando...' : 'Enviar Solicitação'}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default ContactForm;